<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none" fill-rule="evenodd">
    <rect width="24" height="24" fill="#AAEBCE" rx="1.6"/>
    <rect width="12" height="12" x="6" y="6" fill="#3DD7AB" rx=".8"/>
  </g>
</svg>
